import React from "react";
import { cn } from "./cn";

/**
 * Encabezado de tarjeta/sección: título a la izquierda, acciones a la derecha.
 * Unifica el bloque que cada tarjeta resolvía con su propio `<header>`.
 */
export interface SectionHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  actions,
  className,
}) => (
  <header
    className={cn(
      // Una sola línea siempre que entre. El título puede encogerse hasta cero
      // (min-w-0), así las acciones se quedan alineadas con él en vez de caerse
      // a la línea de abajo; sólo envuelven si de verdad no hay lugar.
      "flex flex-wrap items-start justify-between gap-x-4 gap-y-3 pb-5",
      className
    )}
  >
    <div className="min-w-0 flex-1 text-left">
      <h2 className="truncate text-[17px] font-semibold text-gray-900 dark:text-white">
        {title}
      </h2>
      {description ? (
        <p className="mt-1 text-[13px] leading-relaxed text-gray-700 dark:text-gray-400">
          {description}
        </p>
      ) : null}
    </div>

    {actions ? (
      <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
        {actions}
      </div>
    ) : null}
  </header>
);

export default SectionHeader;
